export enum FlyoutSize {
	Auto = 'auto',
	Small = 'small',
	Medium = 'medium',
	Large = 'large',
	Full = 'full',
}

export enum FlyoutState {
	OPEN,
	CLOSED,
}

export declare namespace Flyout {
	export type EFlyoutSize = FlyoutSize;
}
